<template>
    <div id="pos-staff-popup">
        
    </div>
</template>

<script>
export default {
    name: 'pos-staff-popup',
    data() {
        return {

        }
    }
}
</script>